<template>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" @close="close" :close-on-click-modal="false" :close-on-press-escape="false" width="900px">
        <el-form size="small" :model="form" :rules="formRules" :label-width="formLabelWidth" ref="form">

            <el-form-item label="分类" prop="category_id">
                <el-radio-group v-model="form.category_id" @change="courseTypeChangeCate">
                    <el-radio :label="1" >每周一课</el-radio>
                    <el-radio :label="2" >VR</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="类型" prop="course_type">
                <el-radio-group v-model="form.course_type" @change="courseTypeChange">
                    <el-radio :label="1" >图文</el-radio>
                    <el-radio :label="2" >视频</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="标题" prop="title">
                <el-input v-model="form.title" placeholder="标题" clearable/>
            </el-form-item>

            <el-form-item label="封面" prop="image_id">
                <el-row>
                    <el-button type="primary" @click="openProductUpload('image', 'thumb')">选择图片</el-button>
                    <div v-if="form.image_id !== ''" class="img">
                        <img :src="file_path" width="100" height="100" />
                    </div>
                </el-row>
            </el-form-item>

            <el-form-item label="视频：" v-if="form.course_type === 2">
                <el-row>
                    <div class="draggable-list">
                        <div class="item img-select" v-if="form.video_id===0" @click="openProductUpload('video', 'video')"><i class="el-icon-plus"></i></div>
                        <div v-if="form.video_id>0">
<!--                            <video width="150" height="150" :src="form.video.file_path" :autoplay="false" controls>-->
<!--                                您的浏览器不支持 video 标签-->
<!--                            </video>-->
                            <video ref="video" v-if="form.video_id > 0" width="50%" height="50%" controls>
                                <source :src="form.video.file_path" type="video/mp4">
                                <object :data="form.video.file_path" width="100%" height="100%">
                                    <embed :src="form.video.file_path" width="100%" height="100%">
                                </object>
                            </video>
                            <div>
                                <el-button icon="el-icon-picture-outline" @click="delVideo">删除视频</el-button>
                            </div>
                        </div>
                    </div>
                </el-row>
            </el-form-item>

            <el-form-item label="观看停留时间" prop="watch_time" v-if="form.course_type === 1">
                <el-input v-model.number="form.watch_time" placeholder="标题" clearable/>
                <div class="tips">观看停留时间, 单位:秒。 观看多少秒后为已学习该课程</div>
            </el-form-item>

            <el-form-item label="虚拟学习人数" prop="virtual_student_num" v-if="form.category_id === 1">
                <el-input v-model.number="form.virtual_student_num" placeholder="标题" clearable/>
                <div class="tips">虚拟学习人数，小程序端展示: 虚拟学习人数+真实学习人数</div>
            </el-form-item>

            <el-form-item label="内容" prop="content">
                <Editor :text="form.content" @get-content="contentChangeFunc" :width="600" ></Editor>
            </el-form-item>

<!--            <el-form-item label="分数" prop="score">-->
<!--                <el-input-number v-model="form.score" @change="handleScoreChange" :min="1" :max="100" label="分数"></el-input-number>-->
<!--            </el-form-item>-->

            <el-form-item label="状态">
                <el-radio-group v-model="form.status">
                    <el-radio :label="1">启用</el-radio>
                    <el-radio :label="0">禁用</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="排序" prop="sort">
                <el-input v-model.number="form.sort" autocomplete="off"></el-input>
                <div class="tips">越小越靠前</div>
            </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="save" :disabled="submit_loading">确 定</el-button>
        </div>
        <!--上传图片组件-->
        <Upload v-if="isupload" :config.sync="file_config" :isupload="isupload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
    </el-dialog>
</template>

<script>
    import { courseEdit, courseDetail } from '@/api/education';
    import Upload from '@/components/file/Upload';
    import Editor from '@/components/tsk/editor'

    export default {
        components: { Upload, Editor },
        data() {
            return {
                title: '',
                form: {
                    course_id: '',
                    image_id: '',
                    title: '',
                    video: [],
                    video_id: 0,
                    video_url: '',
                    content: '',
                    course_type: 1,
                    category_id: 1,
                    watch_time: 0,
                    virtual_student_num: 0,
                    sort: 0,
                    status: 1,
                },
                file_path: '',
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                dialogFormVisible: false,
                /*是否正在提交*/
                submit_loading: false,
                /*链接选择*/
                is_linkset: false,
                // 验证
                formRules: {
                    title: [{
                        required: true,
                        message: '请输入标题',
                        trigger: 'blur'
                    }]
                },
                /*上传图片*/
                isupload: false,
                file_config: {
                    total: 1,
                    file_type: 'image'
                },

            };
        },
        props: ['fetch-data'],
        created() {

        },
        methods: {
            showDialog(row) {
                if (!row) {
                    this.title = '添加课程'
                } else {
                    this.title = '编辑课程'
                    this.form.course_id = row.course_id
                    this.getDetail()
                }
                this.dialogFormVisible = true
            },
            // 关闭
            close() {
                this.form = this.$options.data().form
                this.form.content = ''
                this.dialogFormVisible = false
            },
            // 保存
            save() {
                this.$refs['form'].validate(async (valid) => {
                    if (valid) {
                        this.submit_loading = true
                        courseEdit(this.form).then((result)=>{
                            this.$message({message: result.msg, type: 'success'});
                            this.$emit('fetch-data')
                            this.submit_loading = false
                            this.close()
                        }).catch(()=>{
                            this.submit_loading = false
                        })
                    }
                })
            },
            getDetail(){
                courseDetail({id: this.form.course_id}).then((result)=>{
                    this.form = Object.assign({}, result.data)
                    this.file_path = result.data.file_path
                })
            },

            courseTypeChange(val){
                this.form.course_type = val
            },
            courseTypeChangeCate(val){
                this.form.category_id = val
            },
            contentChangeFunc(val){
                this.form.content = val
            },
            /*打开上传图片*/
            openProductUpload: function(file_type, file_name) {
                this.file_name = file_name;
                if (file_name === 'thumb') { // 封面图
                    this.file_config = {
                        total: 1,
                        file_type: 'image'
                    };
                }
                if(file_name === 'images'){
                    this.file_config = {
                        total: 9,
                        file_type: 'image'
                    };
                }

                if(file_name === 'video'){
                    this.file_config = {
                        total: 1,
                        file_type: 'video'
                    };
                }

                this.isupload = true;
            },

            /*上传商品图片*/
            returnProductImgsFunc(e) {
                if (e === null) {
                    this.isupload = false
                    return
                }
                if (this.file_name === 'thumb') { // 封面图
                    this.form.image_id = e[0].file_id;
                    this.file_path = e[0].file_path;
                }
                if (this.file_name === 'images') { // 产品图多张
                    for (let i = 0, e_length = e.length; i < e_length; i++) {
                        if (this.form.images.length >= 9) {
                            this.isupload = false
                            this.$message({message: '最多只能选择9张图片', type: 'error'});
                            return
                        }
                        let is_file = false
                        this.form.images.map((item)=>{
                            if(item.file_id === e[i].file_id){
                                is_file = true
                            }
                        })
                        if(is_file === false){
                            this.form.images.push(e[i])
                        }
                    }
                }
                if (this.file_name === 'video') { // 视频
                    this.form.video_id = e[0].file_id;
                    this.form.video = e[0]
                }
                this.isupload = false;
            },

            /*删除文件*/
            deleteImg(index) {
                this.form.images.splice(index, 1);
            },
            delVideo(){
                this.form.video_id = 0;
                this.form.video = [];
            },

        }
    };
</script>

<style scoped>

    .tips {
        color: #ccc;
    }
    .draggable-list {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
    }
    .draggable-list .wrapper > span {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
    }

    .draggable-list .item {
        position: relative;
        width: 110px;
        height: 110px;
        margin-top: 10px;
        margin-right: 10px;
        border-radius: 8px;
        overflow: hidden;
        border: 1px solid #dddddd;
    }

    .draggable-list .delete-btn {
        position: absolute;
        top: 0;
        right: 0;
        width: 16px;
        height: 16px;
        background: red;
        line-height: 16px;
        font-size: 16px;
        color: #ffffff;
        display: none;
    }

    .draggable-list .item:hover .delete-btn {
        display: block;
    }

    .draggable-list .item img {
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        max-height: 100%;
        max-width: 100%;
    }

    .draggable-list .img-select {
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px dashed #dddddd;
        font-size: 30px;
    }

    .draggable-list .img-select i {
        color: #409eff;
    }
</style>



// WEBPACK FOOTER //
// src/views/education/course/course/edit.vue